import { useHistory } from "react-router";
import { useState } from "react";
import { LineDetailsPartial } from "./LineDetailsPartial";
import { useCreateMooringLine } from "../api/api";

type LineDetailsRouteProps = {
  match: {
    params: {
      shipId: string;
    };
  };
};

type CablePayload = Record<string, unknown>;

type ApiError = {
  message?: Record<string, unknown>;
};

export const LineDetailsNew = (props: LineDetailsRouteProps) => {
  const { shipId } = props.match.params;

  const history = useHistory();

  const [editedCable, setEditedCable] = useState<CablePayload>({});
  const [error, setError] = useState<ApiError | undefined>();

  const createCable = useCreateMooringLine(shipId, {
    onSuccess: () => {
      if (history.length > 0) {
        history.goBack();
      } else {
        history.push(`/ships/${shipId}/lines/`);
      }
    },
    onError: ((err: ApiError) => setError(err)) as () => void,
  }) as unknown as {
    mutate: (payload: CablePayload) => void;
  };

  return (
    <LineDetailsPartial
      title="New line"
      backLink={`/ships/${shipId}/lines/`}
      submitButtonTitle="Create"
      editedCable={editedCable}
      error={error}
      setEditedCable={setEditedCable}
      onSubmitClick={() => {
        createCable.mutate(editedCable);
      }}
    />
  );
};
